module.exports = __webpack_public_path__ + "img/idh.3e6e1f91.png";